(function() { window.GUID_532c803c_dfbc_40ca_8593_4ab0a98bbbe1 = { getGuid: function() { return "532c803c-dfbc-40ca-8593-4ab0a98bbbe1"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class TimePicker extends Controls.ControlValueBase {
            constructor(id) {
                super(id);
            }
            OnBindEvents() {
                let me = this;
                CS.Controls.DropDownPicker.Events.ValueChange(Controls.DropDownPicker, {
                    selector: me.$Control,
                    childSelector: ".dropdown-picker",
                    callback: (control, e) => {
                        me.pushDropDownValuesToHidden();
                    }
                });
            }
            pushDropDownValuesToHidden() {
                let $hour = this.$divContainer.find("#dropdown-" + this.ControlId + "-dropdownpicker-hour-hidden");
                let $minute = this.$divContainer.find("#dropdown-" + this.ControlId + "-dropdownpicker-minute-hidden");
                let $amPm = this.$divContainer.find("#dropdown-" + this.ControlId + "-dropdownpicker-ampm-hidden");
                this.$hidden.val($hour.val() + ":" + $minute.val() + ":00" + " " + $amPm.val());
            }
            OnDispose() {
            }
            get ControlId() {
                return this.$divContainer.attr('id');
            }
            get $Control() {
                return this.$divContainer;
            }
            OnControlInstantiation(params) {
                this.$divContainer = $(params[0]); //contient le Id
                this.$hidden = this.$divContainer.find("#" + this.ControlId + "-hidden");
            }
        }
        Controls.TimePicker = TimePicker;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=timepicker.js.map
